import { Navigate, Outlet } from "react-router";
import { Badge, Tag } from "antd";
import { Toolbar } from "@/components/Toolbar";
import { useAuthStore } from "@/stores/auth";
import { useWsStore } from "@/stores/ws";
import { useStatusBarStore } from "@/stores/statusbar";

const statusColor = (s: string) =>
  s === "running" ? "green" : s === "busy" ? "orange" : "default";

export function MainLayout() {
  const { accessToken } = useAuthStore();
  const { connected } = useWsStore();
  const { adapterType, model, sessionStatus } = useStatusBarStore();

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ display: "flex", height: "100vh", width: "100vw", flexDirection: "column" }}>
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <Toolbar />
        <div style={{ flex: 1, overflow: "hidden", background: "var(--content-bg, #F5F7FA)", display: "flex", flexDirection: "column" }}>
          <Outlet />
        </div>
      </div>
      {/* Global StatusBar */}
      <div style={{
        height: 26, flexShrink: 0, display: "flex", alignItems: "center",
        padding: "0 12px", fontSize: 12,
        background: "var(--toolbar-bg, #1B2533)",
        color: "var(--toolbar-icon, #8899AA)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}>
        <Badge status={connected ? "success" : "error"} text={<span style={{ color: "#8899AA", fontSize: 12 }}>{connected ? "Connected" : "Disconnected"}</span>} />
        <div style={{ flex: 1 }} />
        {adapterType && <span style={{ marginRight: 8, color: "#8899AA" }}>{adapterType}</span>}
        {model && <span style={{ marginRight: 8, color: "#C0C8D0" }}>{model}</span>}
        {sessionStatus && (
          <Tag color={statusColor(sessionStatus)} style={{ fontSize: 10, margin: 0, lineHeight: "16px" }}>
            {sessionStatus}
          </Tag>
        )}
      </div>
    </div>
  );
}
